import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { BcCircleLoadingBehavior } from '@bancolombia/design-system-behaviors';
import * as i1 from '@bancolombia/design-system-web/bc-helpers';
import * as i2 from '@bancolombia/design-system-web/bc-loader';
import { BcLoaderModule } from '@bancolombia/design-system-web/bc-loader';
import { CommonModule } from '@angular/common';

class BcCircleLoadingService {
}
BcCircleLoadingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcCircleLoadingService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BcCircleLoadingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcCircleLoadingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcCircleLoadingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Importa las alertas con los diseños de Bancolombia S.A.
 * Las alertas corresponde a un cuadro de diálogo que disponibiliza
 * información de manera flotante o fija.
 *
 * @export
 * @class BcCircleLoadingComponent
 * @implements {AfterViewInit}
 */
class BcCircleLoadingComponent {
    constructor(helper) {
        this.helper = helper;
        /**
         * Texto principal del circle loading.
         *
         * @type {string}
         * @memberof BcCircleLoadingComponent
         */
        this.text = '';
        /**
         * Tamaño del componente Loader.
         *
         * @type {string}
         * @memberof BcLoaderComponent
         */
        this.sizeLoader = 'xl';
        /**
         * Id del componente.
         *
         * @type {string}
         * @memberof BcCircleLoadingComponent
         */
        this.componentId = this.helper.getId(this);
        /**
         * Texto - label de accesibilidad circle loading.
         *
         * @type {string}
         * @memberof BcCircleLoadingComponent
         */
        this.accessibilityLabel = '';
        /**
         * Velocidad bc-loader
         *
         * @type {string}
         * @memberof BcLoaderComponent
         */
        this.speedLoader = '0.5';
        this.bcCircleLoaderBehavior = new BcCircleLoadingBehavior();
    }
    /**
     * Muestra el circle loading.
     * @type {string}
     * @memberof BcCircleLoadingComponent
     */
    showCircleLoading() {
        this.bcCircleLoaderBehavior.showCircleLoading();
    }
    /**
     * Oculta el circle loading.
     *
     * @memberof BcCircleLoadingComponent
     */
    hideCircleLoading() {
        this.bcCircleLoaderBehavior.hideCircleLoading();
    }
    ngAfterViewInit() {
        this.bcCircleLoaderBehavior.setId(this.componentId);
        this.bcCircleLoaderBehavior.setUp();
    }
}
BcCircleLoadingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcCircleLoadingComponent, deps: [{ token: i1.BcHelperService }], target: i0.ɵɵFactoryTarget.Component });
BcCircleLoadingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: BcCircleLoadingComponent, selector: "bc-circle-loading", inputs: { text: "text", sizeLoader: "sizeLoader", componentId: "componentId", accessibilityLabel: "accessibilityLabel", speedLoader: "speedLoader" }, ngImport: i0, template: "<article class=\"bc-circle-loading\" [id]=\"componentId\" >\n    <section  class=\"bc-circle-loading-circle\">\n        <bc-loader sizeLoader=\"{{sizeLoader}}\" [speedLoader]=\"speedLoader\" ></bc-loader>\n        <div class=\"bc-circle-loading-info-container\">\n            <p class=\"bc-circle-loading-info bc-text-break\">{{text}}</p>\n            <label class=\"bc-circle-loading-aria-label\" for=\"\" aria-live=\"polite\"\n                [attr.aria-label]=\"accessibilityLabel\"></label>\n        </div>\n    </section>\n</article>", components: [{ type: i2.BcLoaderComponent, selector: "bc-loader", inputs: ["sizeLoader", "colorLoader", "speedLoader"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcCircleLoadingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bc-circle-loading', styles: [], template: "<article class=\"bc-circle-loading\" [id]=\"componentId\" >\n    <section  class=\"bc-circle-loading-circle\">\n        <bc-loader sizeLoader=\"{{sizeLoader}}\" [speedLoader]=\"speedLoader\" ></bc-loader>\n        <div class=\"bc-circle-loading-info-container\">\n            <p class=\"bc-circle-loading-info bc-text-break\">{{text}}</p>\n            <label class=\"bc-circle-loading-aria-label\" for=\"\" aria-live=\"polite\"\n                [attr.aria-label]=\"accessibilityLabel\"></label>\n        </div>\n    </section>\n</article>" }]
        }], ctorParameters: function () { return [{ type: i1.BcHelperService }]; }, propDecorators: { text: [{
                type: Input
            }], sizeLoader: [{
                type: Input
            }], componentId: [{
                type: Input
            }], accessibilityLabel: [{
                type: Input
            }], speedLoader: [{
                type: Input
            }] } });

/**
 * Importa el componente bcCircleLoading con
 * los diseños de Bancolombia S.A.
 *
 * @componente <bc-circle-loading></bc-circle-loading>
 *
 * @param  text: Texto general del componente de carga
 * @param  accessibilityLabel: Texto usado para ayuda en la accesibilidad, usado para dar la descripción del estado de carga para los lectores de pantalla
 * @param  speedLoader: Velocidad de la animación del loader, para mayor info consultar el componente <bc-loader>.
 * @param componentId: ID que se le asignará en el html del componente, debe ser asignado para
 * facilitar la automatizacion y la certificación
 *
 * @example
 *
 * <bc-circle-loading
 *  text="Cargando..."
 *  id="ejemplo"
 *  accessibilityLabel="ejemplo de aria label"
 *  speedLoader="2">
 * </bc-circle-loading>
 *
 * @author: Bancolombia S.A
 */
class BcCircleLoadingModule {
}
BcCircleLoadingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcCircleLoadingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BcCircleLoadingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcCircleLoadingModule, declarations: [BcCircleLoadingComponent], imports: [BcLoaderModule, CommonModule], exports: [BcCircleLoadingComponent] });
BcCircleLoadingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcCircleLoadingModule, imports: [[BcLoaderModule, CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BcCircleLoadingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BcCircleLoadingComponent],
                    imports: [BcLoaderModule, CommonModule],
                    exports: [BcCircleLoadingComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BcCircleLoadingComponent, BcCircleLoadingModule, BcCircleLoadingService };
